import { t } from '@avalara/bat-apps-shared/i18n';
import { SDialog } from '@avalara/skylab-sdk/react';
import { useState } from 'react';

import './product-catalog.css';

type Props = {
  productTitle: string;
  dialogOpen: boolean;
  schedulingInProgress: boolean;
  hasError: boolean;
  handleDismissDialog: () => void;
};

const ContactDialog = ({ productTitle, dialogOpen, schedulingInProgress, hasError, handleDismissDialog }: Props) => {
  // SDialog can close itself internally (Escape key sets its own `open` prop to false) before
  // s-dismiss fires — the event is a notification that it already happened, not a cancelable
  // request, so preventDefault() has no effect. Since `open` is a mutable Stencil prop, forcing a
  // re-render (regardless of prop-value equality) re-asserts open=true onto the element and
  // reopens it — @avalara/skylab-sdk's react wrapper reapplies every prop on every update.
  const [, forceReassertOpen] = useState(0);

  const handleNativeDismiss = () => {
    if (schedulingInProgress) {
      forceReassertOpen((count) => count + 1);
      return;
    }
    handleDismissDialog();
  };

  return (
    <SDialog
      id='product-catalog-contact-dialog'
      data-ref='buy.product-catalog.contact-dialog'
      onS-dismiss={handleNativeDismiss}
      open={dialogOpen}
      noDismiss={schedulingInProgress}
      style={{ maxHeight: '90vh' }}
    >
      <div slot='header' data-ref='buy.product-catalog.contact-dialog.header'>
        {t('client.product-catalog.contact-dialog.title')}
      </div>
      <div
        slot='body'
        id='product-catalog-contact-dialog-body'
        data-ref='buy.product-catalog.contact-dialog.body'
        className='flex flex-dir-col'
      >
        <p className='font-light pad-bottom-lg'>
          {t('client.general.schedule-a-call-with-an-account-representative-to-buy-or-lea')} {productTitle}.
        </p>
        {hasError && (
          <p className='font-light pad-bottom-lg' data-ref='buy.product-catalog.contact-dialog.error'>
            {t('client.product-catalog.contact-dialog.error')}
          </p>
        )}
        <div
          id='product-catalog-chilipiper-calendar'
          data-ref='buy.product-catalog.contact-dialog.chilipiper-calendar'
        />
      </div>
      <div slot='footer' data-ref='buy.product-catalog.contact-dialog.footer'>
        <button
          type='button'
          data-ref='buy.product-catalog.contact-dialog.close-button'
          className='secondary'
          onClick={handleDismissDialog}
        >
          {t('client.buttons.close')}
        </button>
      </div>
    </SDialog>
  );
};

export default ContactDialog;
